/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectRssIcon20Regular = forwardRef('NetConnectRssIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.516 5.906a9.75 9.75 0 0 0-3.98-.645.75.75 0 0 1-.071-1.498 11.25 11.25 0 0 1 11.772 11.773.75.75 0 0 1-1.498-.071 9.751 9.751 0 0 0-6.223-9.559Z" }),
        React.createElement("path", { d: "M6.616 10.533a4.75 4.75 0 0 0-2.048-.263.75.75 0 1 1-.137-1.494 6.25 6.25 0 0 1 6.793 6.792.75.75 0 1 1-1.494-.136 4.75 4.75 0 0 0-3.114-4.899Z" }),
        React.createElement("path", { d: "M5 16.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" })));
});
